import React, { useEffect } from 'react';
import InlineSVG from 'svg-inline-react';
import useIntersectObserver from '../../constants/useIntersectObserver';
import {
  FacebookShareButton,
  LinkedinShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from 'react-share';

const svgLogoTwitter = '<svg enable-background="new 0 0 512 512" viewBox="0 0 512 512" xmlns="http://www.w3.org/2000/svg"><path d="m512 97.248c-19.04 8.352-39.328 13.888-60.48 16.576 21.76-12.992 38.368-33.408 46.176-58.016-20.288 12.096-42.688 20.64-66.56 25.408-19.264-20.512-46.72-33.216-76.672-33.216-58.112 0-104.896 47.168-104.896 104.992 0 8.32.704 16.32 2.432 23.936-87.264-4.256-164.48-46.08-216.352-109.792-9.056 15.712-14.368 33.696-14.368 53.056 0 36.352 18.72 68.576 46.624 87.232-16.864-.32-33.408-5.216-47.424-12.928v1.152c0 51.008 36.384 93.376 84.096 103.136-8.544 2.336-17.856 3.456-27.52 3.456-6.72 0-13.504-.384-19.872-1.792 13.6 41.568 52.192 72.128 98.08 73.12-35.712 27.936-81.056 44.768-130.144 44.768-8.608 0-16.864-.384-25.12-1.44 46.496 29.984 101.6 47.104 161.024 47.104 193.152 0 298.752-160 298.752-298.688 0-4.64-.16-9.12-.384-13.568 20.832-14.784 38.336-33.248 52.608-54.496z" fill="#ffffff"/></svg>';
const svgLogoFacebook = '<svg viewBox="-21 -21 682.66669 682.66669" xmlns="http://www.w3.org/2000/svg"><path d="m604.671875 0h-569.375c-19.496094.0117188-35.30078125 15.824219-35.296875 35.328125v569.375c.0117188 19.496094 15.824219 35.300781 35.328125 35.296875h306.546875v-247.5h-83.125v-96.875h83.125v-71.292969c0-82.675781 50.472656-127.675781 124.222656-127.675781 35.324219 0 65.679688 2.632812 74.527344 3.808594v86.410156h-50.855469c-40.125 0-47.894531 19.066406-47.894531 47.050781v61.699219h95.9375l-12.5 96.875h-83.4375v247.5h162.796875c19.507813.003906 35.324219-15.804688 35.328125-35.3125 0-.003906 0-.007812 0-.015625v-569.375c-.007812-19.496094-15.824219-35.30078125-35.328125-35.296875zm0 0" fill="#ffffff"/></svg>';
const svgLogoWhatsapp = '<svg viewBox="-23 -21 682 682.66669" xmlns="http://www.w3.org/2000/svg"><path d="m544.386719 93.007812c-59.875-59.945312-139.503907-92.9726558-224.335938-93.007812-174.804687 0-317.070312 142.261719-317.140625 317.113281-.023437 55.894531 14.578125 110.457031 42.332032 158.550781l-44.992188 164.335938 168.121094-44.101562c46.324218 25.269531 98.476562 38.585937 151.550781 38.601562h.132813c174.785156 0 317.066406-142.273438 317.132812-317.132812.035156-84.742188-32.921875-164.417969-92.800781-224.359376zm-224.335938 487.933594h-.109375c-47.296875-.019531-93.683594-12.730468-134.160156-36.742187l-9.621094-5.714844-99.765625 26.171875 26.628907-97.269531-6.269532-9.972657c-26.386718-41.96875-40.320312-90.476562-40.296875-140.28125.054688-145.332031 118.304688-263.570312 263.699219-263.570312 70.40625.023438 136.589844 27.476562 186.355469 77.300781s77.15625 116.050781 77.132812 186.484375c-.0625 145.34375-118.304687 263.59375-263.59375 263.59375zm144.585938-197.417968c-7.921875-3.96875-46.882813-23.132813-54.148438-25.78125-7.257812-2.644532-12.546875-3.960938-17.824219 3.96875-5.285156 7.929687-20.46875 25.78125-25.09375 31.066406-4.625 5.289062-9.242187 5.953125-17.167968 1.984375-7.925782-3.964844-33.457032-12.335938-63.726563-39.332031-23.554687-21.011719-39.457031-46.960938-44.082031-54.890626-4.617188-7.9375-.039062-11.8125 3.476562-16.171874 8.578126-10.652344 17.167969-21.820313 19.808594-27.105469 2.644532-5.289063 1.320313-9.917969-.664062-13.882813-1.976563-3.964844-17.824219-42.96875-24.425782-58.839844-6.4375-15.445312-12.964843-13.359374-17.832031-13.601562-4.617187-.230469-9.902343-.277344-15.1875-.277344-5.28125 0-13.867187 1.980469-21.132812 9.917969-7.261719 7.933594-27.730469 27.101563-27.730469 66.105469s28.394531 76.683594 32.355469 81.972656c3.960937 5.289062 55.878906 85.328125 135.367187 119.648438 18.90625 8.171874 33.664063 13.042968 45.175782 16.695312 18.984374 6.03125 36.253906 5.179688 49.910156 3.140625 15.226562-2.277344 46.878906-19.171875 53.488281-37.679687 6.601563-18.511719 6.601563-34.375 4.617187-37.683594-1.976562-3.304688-7.261718-5.285156-15.183593-9.253906zm0 0" fill-rule="evenodd" fill="#ffffff"/></svg>';
const svgLogoLinkedin = '<svg enable-background="new 0 0 24 24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="m23.994 24v-.001h.006v-8.802c0-4.306-.927-7.623-5.961-7.623-2.42 0-4.044 1.328-4.707 2.587h-.07v-2.185h-4.773v16.023h4.97v-7.934c0-2.089.396-4.109 2.983-4.109 2.549 0 2.587 2.384 2.587 4.243v7.801z" fill="#ffffff"/><path d="m.396 7.977h4.976v16.023h-4.976z" fill="#ffffff"/><path d="m2.882 0c-1.591 0-2.882 1.291-2.882 2.882s1.291 2.909 2.882 2.909 2.882-1.318 2.882-2.909c-.001-1.591-1.292-2.882-2.882-2.882z" fill="#ffffff"/></svg>';

const ShareNetworks = () => {

  /**
   * Animações dos elementos
   */
  const [observer, setElements, entries] = useIntersectObserver({
    threshold: 0.1,
    root: null
  });

  useEffect(() => {

    let elements = Array.from(document.getElementsByClassName('js-anime'));

    setElements(elements);
    
  }, [setElements]);

  useEffect(() => {

    entries.forEach(entry => {

      if (entry.isIntersecting) {

        setTimeout(function() {
          entry.target.style.opacity = '1';
          entry.target.classList.remove('-motion');

          observer.unobserve(entry.target);
        }, 200);
      }
    });
  }, [entries, observer]);

  return (
    <>

    <section className="section -cover b-support">

      <div className="container section -holder">

        <div className="grid -wrap -row-1-4-1-5-1">

          <article className="grid -col-a">

            <h2 className="title -chapter upper js-anime -anime -anime-1 -motion" style={{ opacity:'0'}}>
              Compartilhe
            </h2>

            <h3 className="title -larger mt-3 js-anime -anime -anime-2 -motion" style={{ opacity:'0'}}>
              Nos ajude a formar uma rede de troca e colaboração.
            </h3>

          </article>

          <article className="grid -col-b -self-end js-anime -anime -anime-3 -motion" style={{ opacity:'0'}}>

            <p className="text -median">
              Conhece alguém que precisa de ajuda? Conhece alguém que quer ajudar? Então, compartilhe. Um gesto simples seu pode ajudar milhares de pessoas.
            </p>

          </article>

        </div>

        <div className="grid -wrap -row-2-8-2 mt-3 mt-md-9 js-anime -anime -anime-4 -motion" style={{ opacity:'0'}}>

          <article className="grid -col-a">

            <div className="social -wrap">

              <div className="social -link -twitter">
                <TwitterShareButton 
                  url="http://contacomigosim.com.br/" 
                  title="ContaComigo é uma plataforma para as pessoas fazerem o intercâmbio de seus serviços e produtos. Conheça: "
                  via="tomcomunicacao"
                  hashtags={['contacomigo', 'marketplacesolidário', 'solidariedade']}
                />
                <InlineSVG src={svgLogoTwitter} />
                <span className="sr-only">Compartilhar no Twitter</span>
                <h4>Twitter</h4>
              </div>

              <div className="social -link -facebook">
                <FacebookShareButton 
                  url="http://contacomigosim.com.br/" 
                  quote="ContaComigo é uma plataforma para as pessoas fazerem o intercâmbio de seus serviços e produtos. Conheça: http://contacomigosim.com.br/"
                  hashtag="#contacomigo"
                />
                <InlineSVG src={svgLogoFacebook} />
                <span className="sr-only">Compartilhar no Facebook</span>
                <h4>Facebook</h4>
              </div>

              <div className="social -link -whatsapp">
                <WhatsappShareButton 
                  url="http://contacomigosim.com.br/" 
                  title="ContaComigo é uma plataforma para as pessoas fazerem o intercâmbio de seus serviços e produtos. Conheça: "
                  separator=" "
                />
                <InlineSVG src={svgLogoWhatsapp} />
                <span className="sr-only">Compartilhar no Whatsapp</span>
                <h4>Whatsapp</h4>
              </div>

              <div className="social -link -linkedin">
                <LinkedinShareButton 
                  url="http://contacomigosim.com.br/" 
                  title="ContaComigo marketplace solidário"
                  source="ContaComigo"
                  summary="ContaComigo é uma plataforma para as pessoas fazerem o intercâmbio de seus serviços e produtos. Conheça: http://contacomigosim.com.br/"
                />
                <InlineSVG src={svgLogoLinkedin} />
                <span className="sr-only">Compartilhar no Linkedin</span>
                <h4>Linkedin</h4>
              </div>

            </div>

          </article>

        </div>

      </div>

    </section>

    </>
  );
}

export default ShareNetworks;